import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['product-cards', 'product-cards-ga4', 'quick-starts']);
const allowedFixturePaths = new Set(['/ai/settings/frontend']);

export function isFrontendSettingsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('frontendSettingsVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const frontendSettingsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isFrontendSettingsVisualFixtureUrl(window.location.href);
};
